export const heroContent = {
  mainKeyword: '법률사무소 동행 이혼전문변호사',
  attorneyName: '장수진 변호사',
  subtitle: '의뢰인의 아픔에 공감하고 의뢰인이 건강하게 이혼하며 새로운 출발을 할 수 있도록 도움을 주는 따뜻한 변호사',
  badges: [
    '이혼전문변호사',
    '형사전문변호사',
  ],
  ctaText: '상담문의',
  ctaPhone: '010-7773-3080',
  backgroundImage: '/images/bg.jpg',
  attorneyPhotoDark: '/images/pro.webp',
  certificateImage: '/images/dev.webp',
  attorneyPhotoLight: '/images/pro2.webp',
  logoDark: '/images/logo.webp',
  logoLight: '/images/logo2.webp',
};

export const credentialsContent = {
  sectionLabel: 'Credentials',
  items: [
    {
      icon: 'ri-graduation-cap-line',
      title: '사법시험 합격',
      subtitle: '39회 사법시험 / 39기 사법연수원',
    },
    {
      icon: 'ri-building-line',
      title: '국선변호사 활동',
      subtitle: '공익을 위한 법률 지원',
    },
    {
      icon: 'ri-shield-check-line',
      title: '다양한 사건 수행',
      subtitle: '형사사건 800여건 이상 지원',
    },
    {
      icon: 'ri-team-line',
      title: '수원가정법률상담소\n전문변호사단',
      subtitle: '',
    },
  ],
};

export const careerContent = {
  sectionTitle: '장수진 변호사',
  sectionSubtitle: '용인·수원이혼전문변호사',
  attorneyName: '장수진 변호사',
  keyword: '용인·수원이혼전문변호사',
  attorneyPhotoLight: '/images/pro2.webp',
  intro: '의뢰인을 가족처럼 생각하며 열정적으로 사건을 바라보며 연구하고, 의뢰인에게 가장 최선의 방법이 무엇인지 늘 고민하는 변호사입니다.',
  stats: [],
  badges: [
    '대한변호사협회 등록 이혼전문변호사',
    '대한변호사협회 등록 형사전문변호사',
  ],
  careers: [
    '49회 사법고시 합격',
    '수원지방법원 논스톱국선변호사',
    '피해자국선변호사 활동 (성폭력, 아동학대 사건 800여건 이상 지원)',
    '수원지방검찰청 아동학대사례회의 위원',
    '경기남부지방경찰청 행정처분 이의심의위원회 위원',
    '경기남부지방경찰청 교통사고 민간심의위원회 위원',
    '수원가정법률상담소 전문변호사단',
    '한국성폭력위기센터 법률구조 변호사',
    '수원중부경찰서 경미범죄심사위원회 위원',
    '용인서부경찰서 경미범죄심사위원회 위원',
    '수원남부경찰서 선도심사위원회 위원',
    '동탄경찰서 법률상담변호사',
  ],
  keywords: ['용인이혼전문변호사', '수원이혼전문변호사', '장수진변호사'],
};

export const practiceAreasContent = {
  sectionTitle: '주요 수행 영역',
  sectionSubtitle: '용인·수원이혼전문변호사가 사건의 처음부터 마지막까지',
  description: '완성도 있게 사건을 처리할 수 있는 선에서 수임을 조절하기 때문에 의뢰인들의 만족도가 매우 높습니다.',
  areas: [
    {
      title: '이혼전문',
      icon: 'ri-heart-line',
      description: '황혼이혼, 재산분할, 친권·양육권 등 이혼 전반',
      image: '/images/law.jpg',
      items: [
        { text: '황혼이혼', icon: 'ri-home-6-line' },
        { text: '재산분할', icon: 'ri-money-dollar-circle-line' },
        { text: '친권·양육권', icon: 'ri-user-heart-line' },
        { text: '양육비', icon: 'ri-bank-card-line' },
        { text: '면접교섭', icon: 'ri-chat-smile-2-line' },
        { text: '상간녀소송', icon: 'ri-spy-line' },
      ],
      process: [
        { step: 1, title: '초기 상담', description: '전화 또는 방문을 통해 사건의 개요를 파악하고, 의뢰인의 상황과 목표를 상세히 청취합니다.' },
        { step: 2, title: '증거 수집 및 분석', description: '혼인 관계 증명 서류, 재산 내역, 소득 자료 등 필요한 증거를 수집하고 법리적으로 분석합니다.' },
        { step: 3, title: '전략 수립', description: '의뢰인에게 가장 유리한 방향으로 협상 또는 소송 전략을 수립하고, 예상 결과를 상세히 설명드립니다.' },
        { step: 4, title: '조정 및 협상', description: '원만한 합의를 위해 상대방과 조정 절차를 진행하며, 의뢰인의 권리를 최대한 보호합니다.' },
        { step: 5, title: '소송 및 집행', description: '합의가 어려운 경우 법원에 소송을 제기하고, 판결 이후 집행 절차까지 끝까지 조력합니다.' },
      ],
      faq: [
        { question: '이혼 소송 기간은 얼마나 걸리나요?', answer: '사건의 복잡성과 쟁점에 따라 다르지만, 일반적으로 협의이혼은 1~3개월, 재판이혼은 6개월~1년 정도 소요됩니다. 합의 여부와 재산분할 규모에 따라 기간이 달라질 수 있습니다.' },
        { question: '재산분할은 어떻게 결정되나요?', answer: '혼인 기간 중 함께 형성한 재산을 기준으로, 기여도에 따라 분할 비율이 결정됩니다. 전업주부의 경우에도 가사노동의 기여도를 인정받아 통상 30~50%의 재산분할을 받을 수 있습니다.' },
        { question: '양육권은 누구에게 가나요?', answer: '자녀의 복지와 안정적인 양육 환경을 최우선으로 판단합니다. 양육 의사와 능력, 자녀와의 친밀도, 양육 환경 등을 종합적으로 고려하여 결정됩니다.' },
        { question: '상간녀 소송에서 위자료는 얼마나 받을 수 있나요?', answer: '부정행위의 기간과 정도, 혼인 기간, 당사자들의 경제적 상황 등에 따라 다르며, 통상 수백만 원에서 수천만 원 수준입니다. 구체적인 금액은 사건별로 상이하므로 상담을 통해 확인하시는 것이 좋습니다.' },
      ],
    },
    {
      title: '상속',
      icon: 'ri-file-list-line',
      description: '상속포기, 한정승인 등 상속 분쟁 해결',
      image: '/images/inn.jpg',
      items: [
        { text: '상속포기', icon: 'ri-file-shred-line' },
        { text: '한정승인', icon: 'ri-scales-3-line' },
      ],
      process: [
        { step: 1, title: '상속 재산 파악', description: '망인의 재산과 채무 내역을 종합적으로 조사하고, 상속 재산의 전체 규모를 파악합니다.' },
        { step: 2, title: '상속인 관계 확인', description: '상속 순위와 상속인별 상속분을 확인하고, 필요한 가족관계증명서 등 서류를 준비합니다.' },
        { step: 3, title: '전략 선택', description: '상속포기, 한정승인, 단순승인 중 의뢰인에게 가장 유리한 선택지를 분석하고 조언합니다.' },
        { step: 4, title: '법원 신청', description: '선택한 방식에 따라 가정법원에 필요한 서류를 제출하고, 절차를 신속히 진행합니다.' },
        { step: 5, title: '사후 관리', description: '상속 절차 완료 후에도 발생할 수 있는 법적 문제에 대해 지속적으로 조력합니다.' },
      ],
      faq: [
        { question: '상속포기와 한정승인의 차이는 무엇인가요?', answer: '상속포기는 재산과 채무 모두를 상속받지 않는 것이고, 한정승인은 상속 재산의 범위 내에서만 채무를 변제하는 방식입니다. 채무가 재산보다 많은 경우 상속포기가 유리할 수 있습니다.' },
        { question: '상속포기 신청 기한은 언제까지인가요?', answer: '상속이 개시된 날(망인의 사망일)로부터 3개월 이내에 가정법원에 신청해야 합니다. 이 기간을 놓치면 단순승인으로 간주되어 모든 채무를 떠안을 수 있으니 주의가 필요합니다.' },
        { question: '유언장 없이 사망한 경우 상속은 어떻게 되나요?', answer: '민법에서 정한 법정 상속 순위에 따라 상속이 이루어집니다. 배우자는 항상 상속인이 되며, 직계비속(자녀), 직계존속(부모), 형제자매 순으로 상속 순위가 결정됩니다.' },
      ],
    },
    {
      title: '민사소송',
      icon: 'ri-book-open-line',
      description: '소유권이전, 임대차, 손해배상 등 민사 분쟁',
      image: '/images/bas.jpg',
      items: [
        { text: '소유권이전등기', icon: 'ri-home-8-line' },
        { text: '임대차', icon: 'ri-building-4-line' },
        { text: '손해배상', icon: 'ri-hand-coin-line' },
      ],
      process: [
        { step: 1, title: '사건 분석', description: '의뢰인의 상황을 청취하고, 관련 계약서와 증거 자료를 검토하여 법적 쟁점을 분석합니다.' },
        { step: 2, title: '증거 확보', description: '소송에 필요한 증거 자료를 체계적으로 수집하고, 필요시 문서감정이나 사실조회 등 추가 조사를 진행합니다.' },
        { step: 3, title: '내용증명 및 독촉', description: '소송 전 상대방에게 내용증명을 발송하여 원만한 해결을 시도하고, 협상 가능성을 타진합니다.' },
        { step: 4, title: '소송 제기', description: '합의가 어려운 경우 법원에 소장을 제출하고, 변론 준비서면 등을 통해 의뢰인의 주장을 명확히 개진합니다.' },
        { step: 5, title: '판결 및 집행', description: '법원의 판결을 받은 후, 필요시 강제집행 절차를 통해 실질적인 권리 회복을 완수합니다.' },
      ],
      faq: [
        { question: '민사소송 비용은 얼마나 드나요?', answer: '소송 목적의 값(소가)에 따라 인지대와 송달료가 달라집니다. 변호사 비용은 사건의 복잡성과 소송 가액에 따라 상이하므로, 초기 상담을 통해 구체적인 견적을 안내해 드립니다.' },
        { question: '임대차 분쟁에서 보증금을 빨리 돌려받으려면 어떻게 해야 하나요?', answer: '계약 종료 후 임대인이 보증금 반환을 지체하는 경우, 내용증명 발송 후 임차권등기명령 또는 지급명령 신청을 통해 신속히 대응할 수 있습니다. 계약서와 보증금 입금 내역 등 증거를 잘 보관하시는 것이 중요합니다.' },
        { question: '소송까지 가기 전에 해결할 수 있는 방법은 없나요?', answer: '내용증명 발송, 조정 신청, 중재 등 소송 외 분쟁 해결 수단이 있습니다. 저희는 의뢰인의 시간과 비용을 절약하기 위해 가능한 한 합의와 조정을 우선적으로 시도합니다.' },
      ],
    },
    {
      title: '형사소송',
      icon: 'ri-shield-line',
      description: '성범죄, 보이스피싱 등 형사 사건 대응',
      image: '/images/cas.jpg',
      items: [
        { text: '성범죄 피의자', icon: 'ri-user-search-line' },
        { text: '성범죄 피해자', icon: 'ri-emotion-sad-line' },
        { text: '보이스피싱 피의자', icon: 'ri-smartphone-line' },
      ],
      process: [
        { step: 1, title: '긴급 대응', description: '수사 기관의 출석 요구나 압수수색 등 긴급한 상황에서 의뢰인의 권리를 보호하기 위한 즉각적인 법률 조치를 취합니다.' },
        { step: 2, title: '사실 관계 파악', description: '의뢰인과 면밀한 상담을 통해 사건의 경위를 정확히 파악하고, 유리한 증거와 불리한 증거를 모두 검토합니다.' },
        { step: 3, title: '변호 전략 수립', description: '무죄, 죄명 변경, 감경 등 최적의 변호 방향을 설정하고, 수사 및 재판 단계별 대응 전략을 수립합니다.' },
        { step: 4, title: '수사 및 재판 대응', description: '경찰/검찰 수사 단계부터 법원 재판까지 모든 절차에서 의뢰인을 대리하여 적극적으로 변호합니다.' },
        { step: 5, title: '판결 후 대응', description: '판결 결과에 따라 항소 여부를 검토하고, 형 집행 이후에도 발생할 수 있는 법적 문제에 대비합니다.' },
      ],
      faq: [
        { question: '형사 사건에서 초기 대응이 중요한 이유는 무엇인가요?', answer: '수사 초기 단계의 진술과 증거 확보가 전체 사건의 방향을 결정하는 경우가 많습니다. 경찰 출석 전 반드시 변호사와 상담하여 본인의 권리를 이해하고 대응 전략을 준비하는 것이 매우 중요합니다.' },
        { question: '성범죄 피해자로 신고하면 어떤 절차가 진행되나요?', answer: '경찰에 고소장을 제출하면 수사가 개시되고, 피해자 조사, 증거 수집, 피의자 조사 등이 진행됩니다. 저희는 피해자의 2차 피해를 방지하고, 진술의 신빙성을 확보할 수 있도록 조사 단계부터 재판까지 체계적으로 지원합니다.' },
        { question: '보이스피싱 사건에 연루되었는데, 저도 처벌받나요?', answer: '단순히 계좌를 빌려준 경우나 속아서 가담한 경우에는 고의성 여부에 따라 무죄 또는 감경이 가능합니다. 다만 사안마다 판단이 다르므로 조기에 변호사의 조력을 받는 것이 중요합니다.' },
      ],
    },
  ],
};

export const reviewsContent = {
  sectionTitle: '의뢰인과의 약속',
  sectionSubtitle: '의뢰인의 행복을 최우선으로 생각하는 변호사, 장수진입니다',
  reviews: [
    {
      category: '수임 건수 조절',
      text: '완성도 있게 사건을 처리할 수 있는 선에서 수임을 조절합니다. 많은 사건을 무리하게 수임하기보다, 맡은 사건 하나하나에 최선을 다해 의뢰인이 만족할 수 있는 결과를 만들어냅니다.',
      keywords: ['완성도 있는 처리', '철저한 수임 조절', '최선을 다하는 자세'],
    },
    {
      category: '집행절차까지 확실하게',
      text: '소송이 끝난 후 집행절차(강제집행절차)까지 끝까지 조력합니다. 판결문 한 장으로 끝나는 것이 아니라, 의뢰인의 권리가 실질적으로 실현될 때까지 함께합니다.',
      keywords: ['강제집행 지원', '실질적 권리 실현', '끝까지 조력'],
    },
    {
      category: '적극적인 소통',
      text: '의뢰인과 끊임없이 소통하며 의뢰인의 행복을 위한 최선의 방법을 모색합니다. 법률 용어가 아닌 이해하기 쉬운 언어로 설명하고, 언제든 연락 가능한 변호사가 되기 위해 노력합니다.',
      keywords: ['24시간 소통 가능', '이해하기 쉬운 설명', '쉬운 법률 설명'],
    },
    {
      category: '새로운 인생을 위해',
      text: '의뢰인이 건강하게 이혼하며 새로운 출발을 할 수 있도록 도움을 드립니다. 이혼은 끝이 아니라 새로운 시작입니다. 감정적인 치유와 함께 실질적인 조력을 아끼지 않습니다.',
      keywords: ['건강한 이혼', '새로운 시작', '감정적 치유'],
    },
    {
      category: '가족 같은 마음으로',
      text: '의뢰인을 가족처럼 생각하며, 의뢰인에게 가장 최선의 방법이 무엇인지 늘 고민합니다. 단순한 법률 서비스를 넘어, 진정성 있는 조력자로서 의뢰인의 인생에 긍정적인 변화를 만들고자 합니다.',
      keywords: ['가족 같은 진정성', '인생의 긍정적 변화', '진정성 있는 조력'],
    },
    {
      category: '검증된 전문성',
      text: '경찰청, 보호관찰소, 소방서 등 여러 기관에서 강의를 할 정도로 능력 있고 열정적인 변호사입니다. 다양한 기관에서 인정한 법률 전문가로서, 풍부한 실무 경험과 깊이 있는 지식을 바탕으로 의뢰인을 든든하게 지킵니다.',
      keywords: ['다수 기관 강의', '풍부한 실무 경험', '검증된 법률 전문가'],
    },
  ],
};

export const contactContent = {
  sectionTitle: '상담안내',
  sectionSubtitle: '이혼전문변호사 장수진 변호사가 직접 상담해 드립니다. 접수 후 24시간 이내에 회신드리며, 긴급한 사안은 즉시 대응 가능합니다.',
  phone: {
    label: '상담문의',
    number: '010-7773-3080',
    display: '010-7773-3080',
  },
  address: {
    label: '사무실 주소',
    full: '경기도 용인시 수지구 광교중앙로 297, 205호(상현동, 광교2차 푸르지오시티 D동)',
  },
  naverMap: {
    label: '네이버 예약',
    url: 'https://m.booking.naver.com/booking/6/bizes/1539443/items/7203561?area=pll&lang=ko&startDate=2026-08-10&theme=place',
    text: '네이버에서 예약하기',
  },
  businessHours: [
    { day: '월요일', hours: '09:00 - 18:00' },
    { day: '화요일', hours: '09:00 - 18:00' },
    { day: '수요일', hours: '09:00 - 18:00' },
    { day: '목요일', hours: '09:00 - 18:00' },
    { day: '금요일', hours: '09:00 - 18:00' },
    { day: '토요일', hours: '10:00 - 14:00' },
    { day: '일요일·공휴일', hours: '휴무' },
  ],
  reservation: {
    title: '예약 안내',
    subtitle: '네이버 예약으로 빠르고 간편하게',
    guide: '아래 버튼을 클릭하시면 네이버 예약 페이지로 이동합니다. 원하시는 일정을 선택하여 간편하게 예약을 완료하세요.',
    ctaText: '네이버 예약하기',
    quickCallLabel: '빠른 전화 상담',
    quickCallNote: '평일 09:00 - 18:00 · 접수 후 24시간 이내 회신',
  },
};

export const mediaContent = {
  sectionLabel: 'Activities',
  sectionTitle: '강의 · 활동 이력',
  sectionSubtitle: '다양한 기관에서 인정받은 검증된 전문성',
  description: '경찰청, 보호관찰소, 대학교 등 다수의 공공기관과 전문기관에서 강의를 진행한 검증된 법률 전문가입니다.',
  activities: [
    {
      institution: '경기남부지방경찰청',
      role: '여성청소년과 수사 팀장 대상 교육',
      years: ['2017', '2018', '2019'],
      icon: 'ri-shield-star-line',
      category: '수사기관',
    },
    {
      institution: '경찰청',
      role: '진술분석전문가 교육',
      years: ['2017', '2018'],
      icon: 'ri-government-line',
      category: '수사기관',
    },
    {
      institution: '수원보호관찰소',
      role: '강의',
      years: ['2018', '2019'],
      icon: 'ri-building-line',
      category: '법무기관',
    },
    {
      institution: '경기도청',
      role: '성희롱고충상담원 전문화교육',
      years: ['2018'],
      icon: 'ri-community-line',
      category: '공공기관',
    },
    {
      institution: '경기도재난안전본부',
      role: '성폭력예방교육',
      years: ['2018'],
      icon: 'ri-first-aid-kit-line',
      category: '공공기관',
    },
    {
      institution: '수원여자대학교',
      role: '교직원 대상 폭력예방교육',
      years: ['2018'],
      icon: 'ri-school-line',
      category: '교육기관',
    },
    {
      institution: '용인성폭력상담소',
      role: '상담원 대상 교육',
      years: ['2018', '2019'],
      icon: 'ri-heart-pulse-line',
      category: '지원기관',
    },
    {
      institution: '경기남부해바라기센터',
      role: '상담원 교육',
      years: ['2017', '2018'],
      icon: 'ri-flower-line',
      category: '지원기관',
    },
    {
      institution: '천안여성의전화',
      role: '상담원 교육',
      years: ['2018'],
      icon: 'ri-phone-line',
      category: '지원기관',
    },
    {
      institution: 'SBS 그것이 알고싶다',
      role: '세 모자 사건 자문 인터뷰',
      years: ['2015'],
      icon: 'ri-tv-2-line',
      category: '방송출연',
      image: '/images/sho.webp',
    },
  ],
};

export const footerContent = {
  firmName: '법률사무소 동행',
  attorneyName: '장수진 변호사',
  keyword: '용인·수원이혼전문변호사',
  phone: '010-7773-3080',
  address: '경기도 용인시 수지구 광교중앙로 297, 205호(상현동, 광교2차 푸르지오시티 D동)',
  copyright: '법률사무소 동행. All rights reserved.',
  navLinks: [
    { label: '홈', href: '#hero' },
    { label: '변호사 소개', href: '#career' },
    { label: '활동 이력', href: '#media' },
    { label: '수행 영역', href: '#practice' },
    { label: '의뢰인과의 약속', href: '#reviews' },
    { label: '상담안내', href: '#contact' },
  ],
};

export const navContent = {
  logoWhite: '/images/logo2.webp',
  logoDark: '/images/logo3.webp',
  logoAlt: '법률사무소 동행',
  links: [
    { label: '홈', href: '#hero' },
    { label: '변호사 소개', href: '#career' },
    { label: '활동 이력', href: '#media' },
    { label: '수행 영역', href: '#practice' },
    { label: '의뢰인과의 약속', href: '#reviews' },
    { label: '상담안내', href: '#contact' },
  ],
  ctaText: '상담문의',
  ctaPhone: '010-7773-3080',
};